/*jslint node: true*/

"use strict";

var ko = require("pli/knockout");

//-------------------------------------------
function FileViewModel() {

    this.id = ko.observable();
    this.fileName = ko.observable();

    // non-serialized properties
    this.extras = function FileViewModelExtras() { return; };
    this.extras.uploadProgress = ko.observable();
    this.extras.uploadState = ko.observable();
    this.extras.uploadMessage = ko.observable();
    this.extras.allowedExtensions = null;  // Support for multiple file extensions (ie. this.extras.allowedExtensions = "xls,jpg,png,pdf")
}

//-------------------------------------------
FileViewModel.prototype.reset = function resetFileViewModel() {
    this.id(null);
    this.fileName(null);
    this.extras.uploadProgress(null);
    this.extras.uploadState(null);
    this.extras.uploadMessage(null);
};

//-------------------------------------------
FileViewModel.prototype.attachFiles = function attachFile(files) {
    /// <summary>
    /// Attaches uploaded file to the view model
    /// </summary>

    if (files.length === 1) {
        // set values for file
        this.fileName(files[0].name);

        if (this.validateFileExtension()) {
            this.extras.uploadProgress("0%");

            var f = [];
            f[0] = this;
            return f;
        }

        this.updateAttachedFile("fail", "Invalid file '" + this.fileName() + "'.  Only '" + this.extras.allowedExtensions + "' file types are allowed.");
    }

    return null;
};

//-------------------------------------------
FileViewModel.prototype.updateAttachedFile = function updateFile(state, value) {
    /// <summary>
    /// Updates the state of an attached file.
    /// </summary>
    switch (state) {
    case "done":
        this.id(value || null);
        this.extras.uploadProgress(null);
        break;
    case "fail":
        this.extras.uploadProgress(null);
        this.extras.uploadMessage(value);
        break;
    default:
        this.extras.uploadProgress(typeof value === "number" ? "".concat(value).concat("%") : null);
        break;
    }

    this.extras.uploadState(state);
};

//-------------------------------------------
FileViewModel.prototype.getFileExtension = function getFileExtension() {
    if (this.fileName()) {
        return this.fileName().split('.').pop().toLowerCase();
    }

    return null;
};

//-------------------------------------------
FileViewModel.prototype.validateFileExtension = function validateFileExtension() {
    if (!this.extras.allowedExtensions) {
        return true;
    }

    // Split extensions into array if there are multiple file extensions
    var validExtensions = this.extras.allowedExtensions.toLowerCase().split(","),
        fileExtension = this.getFileExtension();

    return ko.utils.arrayFirst(validExtensions, function (ext) { return (fileExtension === ext); });
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Initialization
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
module.exports = function createFileViewModel() {
    return new FileViewModel();
};



//////////////////
// WEBPACK FOOTER
// ./app/filestore/fileViewModel.js
// module id = 507
// module chunks = 49